// Hooks
import useTranslation from '@/utils/hooks/translation/useTranslation';

import { giveawayPickerSteps } from '@/lib/giveawayPicker/steps';

export const SummaryItemTitle = ({ step }) => {
    const { t } = useTranslation('giveaway_picker');

    return (
        <p className="mb-4 text-left text-xs text-icoGray-500">
            <span className="text-icoBlack">
                {t('step')} {giveawayPickerSteps[step].id} :
                <span className="text-icoBlack"> {t(giveawayPickerSteps[step].name)}</span>
            </span>
        </p>
    );
};
